import { Breadcrumbs, Skeleton } from "@mui/material";
import React, { ReactNode } from "react";
import styles from "./Breadcrumb.module.scss";
import { Link } from "react-router-dom";
import cn from "classnames";
import ImportExportButton from "Components/ImportExportFiles/ImportExportButton/ImportExportButton";
import { useInRouteDrawer, useInRouteDetail } from "Components/RouteDrawer/RouteDrawerContext";

export type BreadcrumbItem = {
  /** An empty title renders a skeleton crumb, for records still loading. */
  title: string;
  link: string;
};
type BreadcrumbProps = {
  breads: BreadcrumbItem[];
  children?: ReactNode;
  withLine?: boolean;
  isNeedImport?: boolean;
  isNeedExport?: boolean;
  currentParams?: Record<string, string | number | null | undefined>;
  /** Use keys from importSectionNames object */
  importLink?: string;
  onImportClick?: () => void;
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  breads,
  children,
  withLine,
  currentParams,
  isNeedExport = false,
  isNeedImport = false,
  importLink,
  onImportClick,
}) => {
  // The drawer's header names the page instead.
  const inDrawer = useInRouteDrawer();
  const inDetail = useInRouteDetail();
  if (inDrawer) return inDetail && children ? (
    <div className={styles.breadcrumb__buttons}>{children}</div>
  ) : null;
  return (
    <div
      className={cn(
        styles.breadcrumb_cont,
        withLine && styles.breadcrumb_cont_withLine
      )}
    >
      <Breadcrumbs separator="&#124;" className={styles.breadcrumb}>
        {breads.map(({ title, link }, i) =>
          !title.trim() ? (
            <Skeleton
              key={`pending-${i}`}
              variant="text"
              width={i === breads.length - 1 ? 160 : 80}
              height={i === breads.length - 1 ? 28 : 20}
              className={styles.skeleton}
              aria-label="Loading"
            />
          ) : i === breads.length - 1 ? (
            <div className={styles.breadcrumb__current_text} key={title}>
              <span className={styles.point}></span>
              <span className={styles.title}>{title}</span>
            </div>
          ) : (
            <Link className={styles.breadcrumb__text} key={title} to={link}>
              {title}
            </Link>
          )
        )}
      </Breadcrumbs>
      <div className={styles.breadcrumb__buttons}>
        <ImportExportButton
          isExport={isNeedExport}
          currentParams={currentParams}
          isImport={isNeedImport}
          link={importLink || ""}
          onImportClick={onImportClick}
        />
        {children}
      </div>
    </div>
  );
};
export default Breadcrumb;
